// LOCAL SERVER
export const BASE_URL = "/";
// Production Server base Url
// export const BASE_URL = "https://quickinvest.triplewsols.in";
